<div class="min-h-screen px-4 py-8" *ngIf="!dataLoading">
    <form #leadForm="ngForm" *ngIf="!successMessage" class="w-full">
        <div class="bg-white shadow-md rounded-2xl p-6 w-full" #addLeadContainer>

            <div class="flex flex-col gap-6 w-full">
                <!-- Static Fields -->
                <!-- <div *ngIf="isFixedColumn" class="flex flex-col gap-2">
            <label class="font-medium text-sm requiredValue">Organisation</label>
            <input pInputText [(ngModel)]="createFieldFormValue['company_name']" name="company_name"
              class="p-inputtext-sm border border-gray-300 rounded px-3 py-2" required #org_name="ngModel" />
            <div *ngIf="org_name.errors && isSubmitted" >
              <small *ngIf="org_name.errors['required']" class="text-red-500 text-sm">Enter Organisation Name</small>
            </div>
          </div> -->

                <!-- // prefix first_name and last_name a/ll are required and orefix is select -->

                <!-- prefix -->
                <div *ngIf="isFixedColumn" class="flex flex-col gap-2">
                    <label class="font-medium text-sm requiredValue">Prefix</label>
                    <p-select [options]="prefixOptions" [(ngModel)]="createFieldFormValue['prefix']"
                        name="prefix" class="p-inputtext-sm" [placeholder]="'Select Prefix'"></p-select>
                    <div *ngIf="isSubmitted && !createFieldFormValue['prefix']" class="text-red-500 text-sm">
                        Select Prefix
                    </div>
                </div>

                <div *ngIf="isFixedColumn" class="flex flex-col gap-2">
                    <label class="font-medium text-sm requiredValue">First Name</label>
                    <input pInputText [(ngModel)]="createFieldFormValue['first_name']" name="first_name"
                        class="p-inputtext-sm border border-gray-300 rounded px-3 py-2" required
                        #first_name="ngModel" />
                    <div *ngIf="first_name.errors && isSubmitted">
                        <small *ngIf="first_name.errors['required']" class="text-red-500 text-sm">Enter First
                            Name</small>
                    </div>
                </div>

                <!-- // last_name -->

                <div *ngIf="isFixedColumn" class="flex flex-col gap-2">
                    <label class="font-medium text-sm requiredValue">Last Name</label>
                    <input pInputText [(ngModel)]="createFieldFormValue['last_name']" name="last_name"
                        class="p-inputtext-sm border border-gray-300 rounded px-3 py-2" required #last_name="ngModel" />
                    <div *ngIf="last_name.errors && isSubmitted">
                        <small *ngIf="last_name.errors['required']" class="text-red-500 text-sm">Enter Last Name</small>
                    </div>
                </div>



                <div *ngIf="isFixedColumn" class="flex flex-col gap-2">
                    <label class="font-medium text-sm requiredValue">Contact Email</label>
                    <input pInputText [(ngModel)]="createFieldFormValue['email']" name="email"
                        class="p-inputtext-sm border border-gray-300 rounded px-3 py-2" required
                        #email="ngModel" />
                    <div *ngIf="email.errors && isSubmitted">
                        <small *ngIf="email.errors['required']" class="text-red-500 text-sm">Enter Contact
                            Email</small>
                    </div>
                </div>

                <div *ngIf="isFixedColumn" class="flex flex-col gap-2">
                    <label class="font-medium text-sm">Contact Number</label>
                    <input pInputText [(ngModel)]="createFieldFormValue['phone']" name="phone"
                        class="p-inputtext-sm border border-gray-300 rounded px-3 py-2" />
                </div>

                <!-- Dynamic Fields -->
                <div class="grid grid-cols-1 gap-4 w-full" *ngIf="allLeadFeilds.length > 0">
                    <div *ngFor="let item of allLeadFeilds" [ngClass]="item.is_public ? '' : 'display-none'">
                        <div class="flex flex-col gap-2">
                            <label
                                [ngClass]="item.required ? 'requiredValue font-medium text-sm' : 'font-medium text-sm'">
                                {{ item.label | titlecase }}
                            </label>

                            <!-- Input -->
                            <input *ngIf="item.type !== 'select' && item.type !== 'textarea'" pInputText
                                class="p-inputtext-sm border border-gray-300 rounded px-3 py-2 w-full"
                                [required]="item.required" [(ngModel)]="fieldValues[item.field_name]"
                                name="{{ item.field_name }}" [attr.minlength]="item['min-length']"
                                [attr.maxlength]="item['max-length']" />

                            <!-- Textarea -->
                            <textarea *ngIf="item.type === 'textarea'" pInputTextarea
                                class="p-inputtext-sm border border-gray-300 rounded px-3 py-2 resize-none"
                                [required]="item.required" [(ngModel)]="fieldValues[item.field_name]"
                                name="{{ item.field_name }}" [attr.minlength]="item['min-length']"
                                [attr.maxlength]="item['max-length']"></textarea>

                            <!-- Select -->
                            <p-dropdown *ngIf="item.type === 'select'" [options]="item.data"
                                [(ngModel)]="fieldValues[item.field_name]" name="{{ item.field_name }}"
                                class="p-inputtext-sm" [placeholder]="item.placeholder"></p-dropdown>

                            <!-- Validations -->
                            <div *ngIf="isSubmitted && item.required && !fieldValues[item.field_name]"
                                class="text-red-500 text-sm">
                                Enter {{ item.label }}!
                            </div>

                            <div *ngIf="item.type === 'email' && leadForm.value[item.field_name] && !isValidEmail(fieldValues[item.field_name], leadForm, item.field_name)"
                                class="text-red-500 text-sm">
                                Enter valid email address!
                            </div>

                            <div *ngIf="leadForm.value[item.field_name]?.length < item['min_length']"
                                class="text-red-500 text-sm">
                                {{ item.label }} must be at least {{ item['min-length'] }} characters.
                            </div>

                            <div *ngIf="leadForm.value[item.field_name]?.length > item['max_length']"
                                class="text-red-500 text-sm">
                                {{ item.label }} must be at most {{ item['max-length'] }} characters.
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Submit Button -->
                <div class="mt-2">
                    <p-button type="button" class="w-full" [style]="{'width': '100%'}"
                        label="{{ btnLoading ? 'Saving...' : 'Save' }}"
                        [icon]="btnLoading ? 'pi pi-spin pi-spinner' : 'pi pi-save'" [disabled]="btnLoading"
                        (click)="SaveLead(leadForm.form.valid); scrollToError(leadForm, addLeadContainer)">
                    </p-button>
                </div>
            </div>
        </div>
    </form>

    <!-- Success Message -->
    <div *ngIf="successMessage" class="text-center mt-10 bg-white shadow-md rounded-2xl p-6 ">
        <img src="assets/svg/check.gif" alt="check" class="h-10 mx-auto" />
        <h4 class="mt-4 text-lg font-medium">Thank you for submitting the form.<br />We will get back to you soon.</h4>
    </div>
</div>

<!-- Loader -->
<div *ngIf="dataLoading" class="flex justify-center items-center min-h-screen px-4 py-8">
    <p-progressSpinner></p-progressSpinner>
</div>